import React, { useEffect } from "react";
import styles from "./Legal.module.css";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung – Dr. Fernando International GmbH";
  }, []);

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroOverline}>Datenschutz</div>
        <h1 className={styles.heroTitle}>Datenschutzerklärung</h1>
        <p className={styles.heroDesc}>
          Informationen zur Verarbeitung personenbezogener Daten gemäß Art.
          13/14 DSGVO.
        </p>
      </header>

      <nav className={styles.toc} aria-label="Inhaltsverzeichnis">
        <h3>Inhalt</h3>
        <ul>
          <li>
            <a href="#allgemeine-hinweise">1. Allgemeine Hinweise</a>
          </li>
          <li>
            <a href="#verantwortlicher">2. Verantwortlicher</a>
          </li>
          <li>
            <a href="#datenschutzbeauftragter">3. Datenschutzbeauftragter</a>
          </li>
          <li>
            <a href="#logfiles">
              4. Erhebung von Zugriffsdaten (Server-Logfiles)
            </a>
          </li>
          <li>
            <a href="#google-maps">
              5. Einbindung von Google Maps (2-Klick-Lösung)
            </a>
          </li>
          <li>
            <a href="#webfonts">6. Verwendung lokaler Webfonts</a>
          </li>
          <li>
            <a href="#cookies-localstorage">7. Cookies / Lokale Speicherung</a>
          </li>
          <li>
            <a href="#ssl-tls">8. SSL-/TLS-Verschlüsselung</a>
          </li>
          <li>
            <a href="#rechte">9. Ihre Rechte als betroffene Person</a>
          </li>
          <li>
            <a href="#aktualitaet">10. Aktualität und Änderungen</a>
          </li>
        </ul>
      </nav>

      <div className={styles.content}>
        <section id="allgemeine-hinweise" className={styles.section}>
          <h2>1. Allgemeine Hinweise</h2>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen.
            Personenbezogene Daten werden vertraulich und entsprechend den
            gesetzlichen Datenschutzvorschriften (insbesondere der DSGVO und des
            TTDSG) sowie dieser Datenschutzerklärung verarbeitet.
            Die Nutzung unserer Website ist grundsätzlich ohne Angabe
            personenbezogener Daten möglich. Soweit auf unseren Seiten
            personenbezogene Daten erhoben werden, erfolgt dies stets auf
            freiwilliger Basis.
          </p>
        </section>

        <section id="verantwortlicher" className={styles.section}>
          <h2>2. Verantwortlicher</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          </p>
          <dl className={styles.dl}>
            <dt>Firma</dt>
            <dd>Dr. Fernando International GmbH</dd>

            <dt>Postanschrift</dt>
            <dd>
              Grunewaldstraße 24
              <br />
              12165 Berlin
              <br />
              Deutschland
            </dd>
            <dt>Telefon</dt>
            <dd>+49 30 374 363 70 </dd>
            <dt>E-Mail</dt>
            <dd>
              <a href="mailto:info@fernando-international.com">
                info@fernando-international.com
              </a>
            </dd>
          </dl>
        </section>

        <section id="datenschutzbeauftragter" className={styles.section}>
          <h2>3. Datenschutzbeauftragter</h2>
          <p>
            Für Fragen zur Verarbeitung Ihrer personenbezogenen Daten können Sie
            sich an unseren Datenschutzbeauftragten wenden:
          </p>
          <p>
            Herrn Jochen Lingemann
            <br />
            Kleinaustraße 10
            <br />
            14169 Berlin
            <br />
            Tel: 030 – 81 07 07 – 44
            <br />
            E-Mail:{" "}
            <a href="mailto:lingemann@petruswerk.de">lingemann@petruswerk.de</a>
          </p>
        </section>

        <section id="logfiles" className={styles.section}>
          <h2>4. Erhebung von Zugriffsdaten (Server-Logfiles)</h2>
          <p>
            Beim Aufrufen unserer Website werden automatisch Informationen
            erfasst, die Ihr Browser übermittelt (z. B. IP-Adresse, Datum und
            Uhrzeit des Zugriffs, Browsertyp, verwendetes Betriebssystem,
            Referrer-URL). Diese Daten dienen ausschließlich der Sicherstellung
            des technischen Betriebs, der Systemsicherheit und der Optimierung
            unseres Angebots. Eine Zusammenführung dieser Daten mit anderen
            Datenquellen erfolgt nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit.
            f DSGVO (berechtigtes Interesse an sicherem und stabilem Betrieb).
            Empfänger bzw. Kategorien von Empfängern sind Hosting- und
            IT-Dienstleister (Auftragsverarbeiter gem. Art. 28 DSGVO). Die
            Logfiles werden nur solange gespeichert, wie dies für die genannten
            Zwecke erforderlich ist, und anschließend gelöscht oder
            anonymisiert.
          </p>
        </section>

        <section id="google-maps" className={styles.section}>
          <h2>5. Einbindung von Google Maps (2-Klick-Lösung)</h2>
          <p>
            Auf unserer Website ist eine interaktive Karte von Google Maps
            (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
            Irland) eingebunden. Zum Schutz Ihrer Daten erfolgt die Einbindung
            ausschließlich über eine 2-Klick-Lösung. Beim ersten Aufruf der
            Seite wird keine Verbindung zu den Servern von Google hergestellt
            und keine personenbezogenen Daten übermittelt.
          </p>
          <p>
            Erst nach Ihrer ausdrücklichen Zustimmung („Karte aktivieren“) wird
            die Karte geladen. Dabei können personenbezogene Daten (z. B. Ihre
            IP-Adresse) an Google übertragen und dort verarbeitet werden. Es
            kann nicht ausgeschlossen werden, dass Daten auch in Drittländer (z.
            B. USA) übermittelt werden. Rechtsgrundlage ist Ihre Einwilligung
            gemäß Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung
            jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs. 3
            DSGVO), indem Sie die Karte wieder deaktivieren oder die gespeicherte
            Auswahl im sessionStorage löschen.
          </p>
          <p>
            Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noreferrer"
            >
              Datenschutzerklärung von Google
            </a>
            .
          </p>
        </section>

        <section id="webfonts" className={styles.section}>
          <h2>6. Verwendung lokaler Webfonts</h2>
          <p>
            Diese Website verwendet ausschließlich lokal eingebundene
            Schriftarten (z. B. „Inter“), die von unserem eigenen Server geladen
            werden. Eine Verbindung zu externen Anbietern wie Google Fonts wird
            nicht hergestellt.
          </p>
        </section>

        <section id="cookies-localstorage" className={styles.section}>
          <h2>7. Cookies / Lokale Speicherung</h2>
          <p>
            Unsere Website verwendet keine Tracking-Cookies. Für die 2-Klick-Lösung
            von Google Maps speichern wir ausschließlich einen technischen Status
            (z. B. „Google Maps aktiviert“) im sessionStorage, damit Ihre Auswahl
            während der laufenden Sitzung berücksichtigt wird. Die Speicherung erfolgt
            nur zu diesem technischen Zweck und wird beim Schließen des Tabs/Browsers
            gelöscht.
          </p>
        </section>

        <section id="ssl-tls" className={styles.section}>
          <h2>8. SSL-/TLS-Verschlüsselung</h2>
          <p>
            Zum Schutz der Übertragung vertraulicher Inhalte nutzt diese Website
            eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
            erkennen Sie am Schloss-Symbol in der Adresszeile Ihres Browsers.
          </p>
        </section>

        <section id="rechte" className={styles.section}>
          <h2>9. Ihre Rechte als betroffene Person</h2>
          <p>
            Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art.
            16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung
            (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie
            Widerspruch (Art. 21 DSGVO).
          </p>

          <p>
            Sofern eine Verarbeitung auf Ihrer Einwilligung beruht, können Sie
            diese jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs.
            3 DSGVO).
          </p>

          <p>
            <strong>Einzelfallbezogenes Widerspruchsrecht:</strong> Sie haben
            das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
            ergeben, jederzeit gegen die Verarbeitung Sie betreffender
            personenbezogener Daten, die aufgrund von Art. 6 Absatz 1 Buchstabe
            f DS-GVO (Datenverarbeitung auf der Grundlage einer
            Interessenabwägung) erfolgt, Widerspruch einzulegen. In diesem Fall
            werden Ihre personenbezogenen Daten nicht mehr verarbeitet, es sei
            denn, es stehen zwingende schutzwürdige Gründe für die Verarbeitung
            entgegen, die Ihre Interessen, Rechte und Freiheiten überwiegen,
            oder die Verarbeitung dient der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen.
          </p>

          <p>
            Sie haben zudem das Recht, sich bei einer
            Datenschutzaufsichtsbehörde zu beschweren, insbesondere in dem
            Mitgliedstaat Ihres gewöhnlichen Aufenthaltsortes oder des
            mutmaßlichen Verstoßes. Eine Übersicht der Aufsichtsbehörden finden
            Sie unter:{" "}
            <a
              href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html"
              target="_blank"
              rel="noreferrer"
            >
              www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
            </a>
            .
          </p>
        </section>

        <section id="aktualitaet" className={styles.section}>
          <h2>10. Aktualität und Änderungen</h2>
          <p>
            Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder gesetzliche
            Änderungen kann eine Anpassung erforderlich werden. Die jeweils
            aktuelle Fassung finden Sie jederzeit auf dieser Seite.
          </p>

          <div className={styles.notice}>
            Stand dieser Datenschutzerklärung: Januar 2026
          </div>
        </section>
      </div>
    </main>
  );
}